import type {Concept, LinkTargetConcreteEntityType} from 'domainTypes';
import type {LinkedValueSearchFieldConfig} from 'feature/linkedValueSearch/types';

export const isFieldConfigOfEntityType = (
  entityType: LinkTargetConcreteEntityType,
  fieldConfig?: LinkedValueSearchFieldConfig,
) => {
  if (
    (fieldConfig?.entitySubtypes as Concept[])?.includes(entityType) &&
    fieldConfig?.sourceEntityId
  ) {
    return fieldConfig?.sourceEntityId;
  }
  if (fieldConfig?.entity === entityType && fieldConfig?.sourceEntityId) {
    return fieldConfig?.sourceEntityId;
  }

  return undefined;
};
